<div class="icon-attachment">
    <kendo-svgicon
        size="default"
        [ngClass]="fileExtension()"
        [icon]="chatDocumentService.getAttachmentIcon(document()!.name)"></kendo-svgicon>
  <span
    class="attachment-name"
    #tooltip="matTooltip"
    [matTooltip]="document()?.name ?? ''"
    matTooltipPosition="above"
    [attr.aria-label]="document()?.name ?? ''">{{ displayName() }}</span>
</div>
